var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjuryForsideRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 92,
    viewBox: "0 0 36 92",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.25 69.562-.29 16.54c-8.343 6.2-16.818 6.195-25.425-.01C1.295 62.317-.476 33.953 2.222 1c14.402 0 25.03 6.554 31.885 19.66.904 12.144.38 17.192-.444 25.945l-.014.145-.399 22.812z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryForsideRight);
export default __webpack_public_path__ + "static/media/injury-forside-right.bec351dfd6756b4f44cf0c3a8b32a743.svg";
export { ForwardRef as ReactComponent };